import GenerateProduct from './generateProduct.container';

export default GenerateProduct